// Module
var code = "<md-content class=\"mn-module-body flex layout-column\">\n    <mn-table mn-model=\"{{vm.mnModel}}\" actions=\"vm.actions\" selectable=\"true\" toggle=\"vm.toggle\"\n              mn-query=\"vm.filter\" order=\"-id\"\n              reset=\"vm.reset\"></mn-table>\n</md-content>";
// Exports
module.exports = code;